import { SkillBreakdown } from '../api';

export const getStatColor = (breakdown?: SkillBreakdown) => {
  if (!breakdown) return undefined;
  if (breakdown.total > breakdown.base) return '#3fb950';
  if (breakdown.total < breakdown.base) return '#6d0101';
  return undefined;
};
